import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { ManagementWebhookEventService } from '@core/services/entities/management-webhook-event.service';
import { ManagementWebhookEventResponseDto } from '@domain/management-webhook-event/dtos/management-webhook-event.response.dto';
import { GetManagementWebhookEventRequestDto } from '@domain/management-webhook-event/dtos/get-management-webhook-event.request.dto';
import { ManagementWebhookEventRepository } from '@domain/management-webhook-event/repositories/management-webhook-event.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManagementWebhookEventRepositoryService
  implements ManagementWebhookEventRepository
{
  constructor(
    private managementWebhookEventService: ManagementWebhookEventService,
  ) {}

  get(
    request: GetManagementWebhookEventRequestDto,
  ): Observable<ApiResponse<ManagementWebhookEventResponseDto[]>> {
    return this.managementWebhookEventService.get(request);
  }
}
